export default __webpack_public_path__ + "static/media/pokemon-gray.69bcf754.svg";